<template>
  <div class="app-overlay">
    <div ref="appModalOuter" class="app-modal__outer">
      <div class="app-modal app-modal--large">
        <div class="app-modal__close" @click="clearCar"></div>
        <div class="app-modal__body">
          <div class="checkout" v-show="step === 1">
            <div class="checkout__steps">
              <div class="checkout__steps-item active">
                <div class="checkout__steps-number">1</div>
                <div class="checkout__steps-title">Автомобиль</div>
              </div>
              <div class="checkout__steps-item">
                <div class="checkout__steps-number">2</div>
                <div class="checkout__steps-title">Бронирование</div>
              </div>
              <div class="checkout__steps-item" v-if="car.online_payment_percent > 0">
                <div class="checkout__steps-number">3</div>
                <div class="checkout__steps-title">Оплата</div>
              </div>
              <div class="checkout__steps-item">
                <div class="checkout__steps-number" v-if="car.online_payment_percent > 0">4</div>
                <div class="checkout__steps-number" v-else>3</div>
                <div class="checkout__steps-title">Подтверждение</div>
              </div>
            </div>
            <div class="checkout__wrapper">
              <div class="checkout__left">
                <div class="checkout__title">
                  <div class="checkout__title-text">{{car.model}} <span v-if="car.year">({{car.year}})</span></div>
                  <div class="checkout__title-icon" @click="copyUrl">
                    <a href="javascript:void(0)"></a>
                  </div>
                </div>
                <div class="checkout__images" v-if="car.images.length < 2">
                  <div class="checkout__images-item">
                    <img :src="car.car_model_thumbnail" v-if="car.car_model_thumbnail" alt="">
                  </div>
                </div>
                <div class="checkout__images js-checkout-slider" v-else>
                  <div class="checkout__images-item">
                    <img :src="car.car_model_thumbnail" alt="">
                  </div>
                  <div class="checkout__images-item" v-for="i in car.images">
                    <img :src="i.thumbnail" alt="">
                  </div>
                </div>
                <CarChars :car="car" />
                <div class="checkout__options" v-if="car.equipment">
                  <div class="checkout__options-title" v-if="car.equipment.length > 0">Дополнительные опции</div>
                  <div class="checkout__options-rows">
                    <div class="checkout__options-row" v-for="eq in car.equipment">
                      <div class="checkout__options-control">
                        <div class="custom-control custom-checkbox custom-checkbox--black">
                          <input class="custom-control-input" type="checkbox" :id="`eq${eq.id}`" @change="setEq(eq)">
                          <label class="custom-control-label" :for="`eq${eq.id}`">{{eq.name}}</label>
                        </div>
                      </div>
                      <div class="checkout__options-price">
                        {{eq.price}} <i class="rouble-sign">₽</i>/сут.
                      </div>
                    </div>
                  </div>
                  <div class="checkout__options-total" v-if="eqPrtice > 0">
                    <div class="checkout__options-total_title">Стоимость доп. опций</div>
                    <div class="checkout__options-total_value">{{eqPrtice*car.info.rent_period.rent_days}} <i class="rouble-sign">₽</i></div>
                  </div>
                </div>
              </div>
              <div class="checkout__right">
                <CheckoutPrice :car="car" />
                <CheckoutPlace :car="car" :cars="cars" :locationStart="locationStart" :locationEnd="locationEnd" />
                <CheckoutTotal :car="car" :cars="cars" :eqPrtice="eqPrtice" />
                <div class="checkout__button">
                  <button class="button button--full button--yellow" @click="goToBooking">Перейти к оформлению</button>
                </div>
              </div>
            </div>
          </div>
          <div class="checkout" v-show="step === 2">
            <div class="checkout__steps">
              <div class="checkout__steps-item active" @click="setStep(1)">
                <div class="checkout__steps-number">1</div>
                <div class="checkout__steps-title underline">Автомобиль</div>
              </div>
              <div class="checkout__steps-item active">
                <div class="checkout__steps-number">2</div>
                <div class="checkout__steps-title">Бронирование</div>
              </div>
              <div class="checkout__steps-item" v-if="car.online_payment_percent > 0">
                <div class="checkout__steps-number">3</div>
                <div class="checkout__steps-title">Оплата</div>
              </div>
              <div class="checkout__steps-item">
                <div class="checkout__steps-number" v-if="car.online_payment_percent > 0">4</div>
                <div class="checkout__steps-number" v-else>3</div>
                <div class="checkout__steps-title">Подтверждение</div>
              </div>
            </div>

            <div class="checkout__wrapper">
              <div class="checkout__left">
                <div class="checkout__title">
                  <div class="checkout__title-text underline" @click="setStep(1)">{{car.model}} <span v-if="car.year">({{car.year}})</span></div>
                  <div class="checkout__title-icon" @click="copyUrl">
                    <a href="javascript:void(0)"></a>
                  </div>
                </div>
                <div class="checkout__form">
                  <div class="checkout__form-title">Личные данные</div>
                  <div class="checkout__form-fields">
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Фамилия" v-model.trim="$v.surname.$model" :class="{ 'form-control--error': $v.surname.$error }">
                    </div>
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Имя" v-model.trim="$v.name.$model" :class="{ 'form-control--error': $v.name.$error }">
                    </div>
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Отчество" v-model="middle_name">
                    </div>
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Электронная почта" v-model.trim="$v.email.$model" :class="{ 'form-control--error': $v.email.$error }">
                    </div>
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Телефон" v-model.trim="$v.phone.$model" :class="{ 'form-control--error': $v.phone.$error }">
                    </div>
                  </div>
                </div>
                <div class="checkout__text">Пожалуйста, укажите мессенджеры, к которым привязан ваш телефон. Мы будем стараться сначала связываться через них.</div>
                <div class="checkout__form-controls">
                  <div class="custom-control custom-checkbox custom-checkbox--black">
                    <input class="custom-control-input" type="checkbox" id="telegram" v-model="telegram">
                    <label class="custom-control-label" for="telegram">Telegram</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-checkbox--black">
                    <input class="custom-control-input" type="checkbox" id="WhatsApp" v-model="whatsapp">
                    <label class="custom-control-label" for="WhatsApp">WhatsApp</label>
                  </div>
                  <div class="custom-control custom-checkbox custom-checkbox--black">
                    <input class="custom-control-input" type="checkbox" id="Viber" v-model="viber">
                    <label class="custom-control-label" for="Viber">Viber</label>
                  </div>
                </div>
                <div class="checkout__form">
                  <div class="checkout__form-fields">
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Доп. телефон" v-model="additionalProne">
                    </div>
                  </div>
                </div>
                <div class="checkout__form checkout__form--second">
                  <div class="checkout__form-title checkout__form-title--small">Получение</div>
                  <div class="checkout__form-fields checkout__form-fields--row">
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Номер рейса" v-model="flightNumber">
                    </div>
                    <div class="checkout__form-field">
                      <input type="text" class="form-control" placeholder="Время прибытия (местное)" v-model="flightTime">
                    </div>
                  </div>
                  <!-- <div class="checkout__form-help">*если вас нужно встретить</div> -->
                </div>
              </div>
              <div class="checkout__right">
                <CheckoutPrice :car="car" />
                <CheckoutPlace :car="car" :cars="cars" :locationStart="locationStart" :locationEnd="locationEnd" />
                <CheckoutTotal :car="car" :cars="cars" :eqPrtice="eqPrtice" />
                <div class="checkout__agree">
                  <div class="custom-control custom-checkbox custom-checkbox--black" v-bind:class="{'custom-checkbox--error': agreeError}">
                    <input class="custom-control-input" type="checkbox" id="agree" v-model="agree">
                    <label class="custom-control-label" for="agree"><span>Согласен с <a href="https://naprokat.ru/terms_and_conditions/terms_of_use" target="_blank">пользовательским соглашением</a> и политикой конфинденциальности</span></label>
                  </div>
                </div>
                <div class="checkout__button" v-if="car.online_payment_percent > 0">
                  <vue-ladda button-class="button button--full button--yellow" @click="sendOrder" :loading="sendForm" data-style="expand-right">Забронировать авто</vue-ladda>
                </div>
                <div class="checkout__button" v-else>
                  <vue-ladda button-class="button button--full button--yellow" @click="sendOrder" :loading="sendForm" data-style="expand-right">Забронировать авто</vue-ladda>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Vue from 'vue';
import VueLadda from 'vue-ladda';
import VueClipboard from 'vue-clipboard2';
import moment from 'moment';
import Vuelidate from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import CarChars from '@/components/Checkout/CarChars';
import CheckoutPrice from '@/components/Checkout/Price';
import CheckoutPlace from '@/components/Checkout/Place';
import CheckoutTotal from '@/components/Checkout/Total';

Vue.use(VueToast);
Vue.use(VueClipboard);
Vue.component('vue-ladda', VueLadda);
Vue.use(Vuelidate);

export default {
    name: 'CarItem',
    components: {
      CarChars,
      CheckoutPrice,
      CheckoutPlace,
      CheckoutTotal,
    },
    data() {
      return {
        surname: null,
        name: null,
        middle_name: null,
        email: null,
        phone: null,
        whatsapp: false,
        telegram: false,
        viber: false,
        additionalProne: null,
        flightNumber: null,
        flightTime: null,
        equipment: [],
        sendForm: false,
        agree: false,
        agreeError: false,
      }
    },
    validations: {
      name: {
        required,
        minLength: minLength(2)
      },
      surname: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      },
      phone: {
        required,
        minLength: minLength(6)
      },
    },
    computed: {
      locationStart() {
        return this.$store.getters.locationStart;
      },
      locationEnd() {
        return this.$store.getters.locationEnd;
      },
      car() {
        return this.$store.getters.car;
      },
      cars() {
        return this.$store.getters.cars;
      },
      redirectScreen() {
        return this.$store.getters.redirectScreen;
      },
      parameters() {
        return this.$store.getters.parameters;
      },
      step() {
        return this.$store.getters.step;
      },
      user() {
        return this.$store.getters.user;
      },
      isApp() {
        return this.$store.getters.isApp;
      },
      eqPrtice() {
        return this.equipment.reduce(function(prev, cur) {
          return parseInt(prev) + parseInt(cur.price);
        }, 0);
      },
    },
    mounted() {
      if (this.$route.query.booking && this.$route.query.booking == 1) {
        this.$store.dispatch('setStep', 2);
      }
      $(".js-checkout-slider").slick({
        arrows: false,
        dots:true,
        slidesToScroll:1,
        variableWidth:true,
        mobileFirst: true,
        focusOnSelect: true,
      });
      if (this.user) {
        this.name = this.user.name;
        this.surname = this.user.surname;
        this.middle_name = this.user.middlename;
        this.phone = this.user.phone;
        this.email = this.user.email;
      }

      this.$refs.appModalOuter.classList.add('app-modal-scrollbar-none');
      this.$root.$el.classList.add('app-scrollbar-none');
    },
    beforeDestroy() {
      this.$refs.appModalOuter.classList.remove('app-modal-scrollbar-none');
      this.$root.$el.classList.remove('app-scrollbar-none');
    },
    methods: {
      setStep(step) {
        this.$store.dispatch('setStep', step);
      },
      goToBooking() {
        if (this.car.info.availability.available == true) {
          this.$store.dispatch('setStep', 2);
          this.$router.push({ query: Object.assign({}, this.$route.query, { booking: 1 }) });
        } else {
          Vue.$toast.open({
            position: 'top-right',
            message: this.car.info.availability.notice,
            type: 'error',
          });
        }
      },
      setEq(eq) {
        if (this.equipment.filter(e => e.id == eq.id).length > 0) {
          this.equipment.splice(this.equipment.findIndex((i) => {
            return i.id === eq.id;
          }), 1);
        } else {
          this.equipment.push(eq);
        }
      },
      copyUrl() {
        this.$copyText(document.URL).then(function (e) {
          Vue.$toast.open({
            position: 'top-right',
            message: 'Ссылка успешно скопирована в буфер обмена',
            type: 'success',
          });
        }, function (e) {
          Vue.$toast.open({
            position: 'top-right',
            message: 'Ссылка не скопирована, попробуйте скопировать вручную',
            type: 'error',
          });
        })
      },
      clearCar() {
        this.$store.dispatch('clearCar');
        let query = Object.assign({}, this.$route.query);
        delete query.car;
        delete query.booking;
        this.$router.replace({ query });
        this.$store.dispatch('setStep', 1);
      },
      formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      },
      getDate(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');
      },
      getHour(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('HH:mm');
      },
      sendOrder() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          if (!this.agree) {
            this.agreeError = true;
          } else {
            this.agreeError = false;
          }
          Vue.$toast.open({
            position: 'top-right',
            message: 'Заполните все поля формы',
            type: 'error',
          });
        } else {
          if (!this.agree) {
            Vue.$toast.open({
              position: 'top-right',
              message: 'Необходимо согласиться с пользовательским соглашением и политикой конфиденциальности',
              type: 'error',
            });
            this.agreeError = true;
            return false;
          }
          this.agreeError = false;
          this.sendForm = true;
          const eqFinal = this.equipment.map(function(eq) {
            delete eq.name;
            delete eq.price;
            eq.qty = 1;
            return eq;
          });
          let order = {
            vendor_id: this.locationStart.vendor_id,
            pick_up_location_id: this.locationStart.id,
            drop_off_location_id: this.locationEnd.id,
            pick_up_datetime: this.parameters.pick_up_datetime,
            drop_off_datetime: this.parameters.drop_off_datetime,
            name: this.name,
            middle_name: this.middle_name,
            surname: this.surname,
            vehicle_id: this.car.id,
            email: this.email,
            phone: this.phone,
            equipment: eqFinal,
            extra_fields: {
              whatsapp: this.whatsapp,
              telegram: this.telegram,
              viber: this.viber,
              additionalProne: this.additionalProne,
              flightNumber: this.flightNumber,
              flightTime: this.flightTime,
            },
          }
          this.$store.dispatch('sendOrder', order).then((response) => {
            this.sendForm = false;
            if (this.isApp && response.data.user && response.data.user.api_token) {
              document.location.href = `app://send?token=${response.data.user.api_token}`
            }
            if (this.car.online_payment_percent > 0) {
              this.clearCar();
              this.$store.dispatch('setRedirectScreen');
              setTimeout(() => {
                const parameters = {
                  id: response.data.uuid,
                  redirect_url: `${location.protocol}//${location.host}/order/${response.data.uuid}`,
                }
                this.$store.dispatch('getPayLink', parameters).then((resp) => {
                  document.location.href=resp.data.payment_url;
                });
              }, 3000);
            } else {
              this.clearCar();
              this.$router.push(`/order/${response.data.uuid}`);
            }
          })
        }
      },
    }
}
</script>

<style>
  .checkout__images-item img {
    height: auto !important;
  }
  .checkout__images {
    overflow: visible !important;
  }
  .form-control--error {
    border-color: red !important;
  }
  .ladda-button {
    background-color: #fed01f !important;
    color: #000 !important;
  }
  .checkout__steps-item.active {
    cursor: pointer;
  }
  .underline {
    text-decoration: underline;
    cursor: pointer;
  }
  .custom-checkbox--error .custom-control-label:before {
    border-color: red !important;
    border-width: 2px !important;
  }
  .js-checkout-slider .checkout__images-item:after {
    width: 320px !important;
  }
  .checkout__images .slick-dots li {cursor: pointer;}
  .app-modal {
    position: relative !important;
    margin-bottom: 30px !important;
  }
  .app-modal__outer.app-modal-scrollbar-none::-webkit-scrollbar {
    /* width: 0; */
  }
  #app.app-scrollbar-none {
    position: relative;
    overflow: hidden;
    height: 100vh;
  }
</style>